import { useState, useCallback } from "react";

export const useShareModal = () => {
  const [showShareModal, setShowShareModal] = useState(false);

  const openShareModal = useCallback(() => {
    setShowShareModal(true);
  }, []);

  const closeShareModal = useCallback(() => {
    setShowShareModal(false);
  }, []);

  return {
    showShareModal,
    setShowShareModal,
    openShareModal,
    closeShareModal,
  };
};
